export const taskEffortAllSelector = (state) =>
  state?.taskEffortReducer?.taskEffortAll;
export const taskEffortOpenAddSelector = (state) =>
  state?.taskEffortReducer?.taskEffortOpenAdd;
export const taskEffortOpenEditSelector = (state) =>
  state?.taskEffortReducer?.taskEffortOpenEdit;
export const taskEffortSelectedSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSelected;
export const taskEffortSearchSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSearch;
//
export const taskEffortCountPassSelector = (state) =>
  state?.taskEffortReducer?.taskEffortCountPass;
export const taskEffortCountWarnSelector = (state) =>
  state?.taskEffortReducer?.taskEffortCountWarn;
export const taskEffortCountDenySelector = (state) =>
  state?.taskEffortReducer?.taskEffortCountDeny;
export const taskEffortSumExpSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSumExp;
export const taskEffortSumEffortSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSumEffort;
export const taskEffortSumEaseSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSumEase;
export const taskEffortSumMistakeSelector = (state) =>
  state?.taskEffortReducer?.taskEffortSumMistake;
